import React, { useState, useEffect, useContext } from 'react';
import { createAppointment, updateAppointment, getAppointments } from '../api/api';
import '../index.css';
import './UserForm.css'; // Usa el mismo CSS que UserForm
import { AuthContext } from '../context/AuthContext';
import Form from './common/Form';
import Input from './common/Input';
import Select from './common/Select';
import Button from './common/Button';
import Error from './common/Error';


const AppointmentForm = ({ appointment, onClose, onAppointmentUpdated, onAppointmentCreated, users }) => {
    const { userRole } = useContext(AuthContext);
    const [formData, setFormData] = useState({
        title: '',
        user: '',
        date: '',
        specialty: '',
        office: '',
        responsible_doctor: '',
        instructions: '',
        address: '',
        appointment_type: 'nutrition',
        location_name: '',
    });
    const [isEditing, setIsEditing] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState("");
    const validAppointmentTypes = [
        "nutrition", "psychology", "external-event", "group-session",
        "quality-of-life", "rehabilitation", "talks", "radiotherapy",
        "laboratory", "anesthesia", "imaging", "pathology", "surgery",
        "chemotherapy"
    ];

    useEffect(() => {
        if (appointment) {
            setIsEditing(true);
            setFormData({ ...appointment });
        }
    }, [appointment]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setMessage("");

        try {
            if (isEditing) {
                const updatedAppointment = await updateAppointment(appointment.id, formData);
                if (updatedAppointment) {
                    onAppointmentUpdated(updatedAppointment);
                    setMessage("Cita actualizada")
                }
                setTimeout(() => {
                    onClose();
                }, 1500);
            } else {
                const newAppointment = await createAppointment(formData);
                onAppointmentCreated(newAppointment);
                setMessage("Cita creada")
                setTimeout(() => {
                    onClose();
                }, 1500);
            }
        } catch (err) {
            setError(err.message || 'Error al procesar la cita');
        }
    };

    return (
        <Form className='form-user' onSubmit={handleSubmit}>
            {message && <div className='container-message'>{message}</div>}
            {error && <Error error={error} />}
            <Input type="text" id="title" name="title" value={formData.title} onChange={handleChange} label="Título" required />
            <Select id="user" name="user" value={formData.user} onChange={handleChange} label="Usuario" required options={users.map(user => ({ value: user.email, label: user.email }))} />
            <Input type="datetime-local" id="date" name="date" value={formData.date} onChange={handleChange} label="Fecha" required />
            <Input type="text" id="specialty" name="specialty" value={formData.specialty} onChange={handleChange} label="Especialidad" required />
            <Input type="text" id="office" name="office" value={formData.office} onChange={handleChange} label="Consultorio" required />
            <Input type="text" id="responsible_doctor" name="responsible_doctor" value={formData.responsible_doctor} onChange={handleChange} label="Doctor Responsable" required />
            <Input type="text" id="instructions" name="instructions" value={formData.instructions} onChange={handleChange} label="Instrucciones" />
            <Input type="text" id="address" name="address" value={formData.address} onChange={handleChange} label="Dirección" required />
            <Select
                id="appointment_type"
                name="appointment_type"
                value={formData.appointment_type}
                onChange={handleChange}
                label="Tipo de Cita"
                required
                options={validAppointmentTypes.map(type => ({ value: type, label: type }))}
            />
            <Input type="text" id="location_name" name="location_name" value={formData.location_name} onChange={handleChange} label="Nombre de la Ubicación" />

            <Button type="submit">{isEditing ? 'Actualizar' : 'Crear'}</Button>
            <Button type='button' onClick={onClose}>Cancelar</Button>
        </Form>
    );
};

export default AppointmentForm;
